import { Box, Button, Typography, useMediaQuery, CircularProgress } from "@mui/material";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { useState } from "react";
import { useRoom } from "../context/RoomContext";

const STEPS = [
  { key: "hotelInfo", labelKey: "StepHotelInfo" },
  { key: "licenseVerification", labelKey: "StepLicenseVerification" },
  { key: "roomInfo", labelKey: "StepRoomInfo" },
  { key: "additionalInfo", labelKey: "StepAdditionalInfo" },
  { key: "paymentMethod", labelKey: "StepPaymentMethod" },
];

const CURRENT_STEP_INDEX = 1;

const HotelAdd_LicVerSubmit = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { id } = useParams();
  const isMobile = useMediaQuery("(max-width:950px)");
  const { createRoom, fetchHotelRoom } = useRoom();
  const [isSaving, setIsSaving] = useState(false);

  const pageStyle = {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    backgroundColor: "#F5F5F5",
  };

  const contentStyle = {
    flex: "1 0 auto",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    padding: isMobile ? "100px 20px 60px" : "120px 80px 80px",
    maxWidth: "1600px",
    width: "100%",
  };

  const handleNext = async () => {
    try {
      setIsSaving(true);
      const hotelRoom = await fetchHotelRoom(id);
      let roomId;
      if (hotelRoom.length > 0) {
        roomId = hotelRoom[0]._id;
      }
      else {
        roomId = await createRoom(id);
      }
      navigate(`/hotel/${id}/room-info-1/${roomId}`);
    } catch (err) {
      console.error("Error creating room:", err);
    } finally {
      setIsSaving(false);
    }
  }

  return (
    <div style={pageStyle}>
      <Navbar />
      <div style={contentStyle}>
        {/* Stepper */}
        <Box sx={{ display: "flex", alignItems: "center", mb: 6, mx: "auto" }}>
          {STEPS.map((step, index) => (
            <Box key={step.key} sx={{ display: "flex", alignItems: "center", flex: 1 }}>
              <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
                <Box
                  sx={{
                    width: isMobile ? "20px" : "30px",
                    height: isMobile ? "20px" : "30px",
                    borderRadius: "50%",
                    backgroundColor: index <= CURRENT_STEP_INDEX ? "#31BACD" : "transparent",
                    border: index <= CURRENT_STEP_INDEX ? "3px solid #fff" : "2px solid #D1D1D1",
                    boxShadow: index <= CURRENT_STEP_INDEX ? "0 0 0 2px #31BACD" : "none",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                />
                <Typography
                  sx={{
                    fontSize: isMobile ? "10px" : "13px",
                    fontWeight: index === CURRENT_STEP_INDEX ? "600" : "400",
                    color: index === CURRENT_STEP_INDEX ? "#000" : "#666",
                    textAlign: "center",
                    whiteSpace: "wrap",
                    width: isMobile ? "50px" : "100px",
                  }}
                >
                  {t(step.labelKey)}
                </Typography>
              </Box>
              {index < STEPS.length - 1 && (
                <Box
                  sx={{
                    height: "1px",
                    width: isMobile ? "30px" : "200px",
                    backgroundColor: "#D1D1D1",
                    mx: "auto",
                    mb: isMobile ? "18px" : "24px",
                  }}
                />
              )}
            </Box>
          ))}
        </Box>

        <Box sx={{ width: isMobile ? "100%" : "60%", mx: "auto", display: "flex", flexDirection: "column" }}>
          {/* Heading */}
          <Box sx={{ mb: 4 }}>
            <Typography
              sx={{
                fontWeight: "bold",
                fontSize: isMobile ? "18px" : "22px",
                color: "#000",
                mb: 1,
              }}
            >
              {t('LicVerSubmitTitle')}
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, justifyContent: "flex-start" }}>
              <Typography
                sx={{
                  fontWeight: "bold",
                  fontSize: isMobile ? "18px" : "22px",
                  color: "black",
                }}
              >
                {t('LicVerSubmitSubtitle')}
              </Typography>
              <img
                src="/icons/hotelPaw.png"
                alt="Hotel Paw"
                style={{
                  width: isMobile ? "30px" : "40px",
                  height: "auto",
                }}
              />
            </Box>
          </Box>

          <Box
            sx={{
              backgroundColor: "#FFFFFF",
              border: "1px solid #E0E0E0",
              borderRadius: "10px",
              padding: isMobile ? "16px" : "20px 24px",
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            <Typography sx={{ fontSize: isMobile ? "12px" : "13px", color: "#888", lineHeight: 1.7 }}>
              {t('LicVerSubmitDesc')}
            </Typography>
          </Box>

          {/* Bottom actions */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              width: "100%",
              mt: 6,
            }}
          >
            
            <Button
              variant="contained"
              onClick={handleNext}
              sx={{
                backgroundColor: "#31BACD",
                color: "#fff",
                borderRadius: "10px",
                textTransform: "none",
                fontSize: isMobile ? "14px" : "16px",
                padding: "10px 32px",
                "&:hover": { opacity: 0.85, backgroundColor: "#31BACD" },
                "&:disabled": { opacity: 0.5, color: "#fff" },
              }}
            >
              {isSaving ? <CircularProgress size={20} color="inherit" /> : t('NextStep')}
            </Button>
          </Box>
        </Box>
      </div>
      <Footer />
    </div>
  );
};

export default HotelAdd_LicVerSubmit;
